<template>
  <v-container class="new-doorphone-page" fluid>
    <v-breadcrumbs :items="items" class="px-0 pt-0 pb-0" />
    <div class="new-doorphone-page__header">
      <h1 class="new-doorphone-page__title">Новый домофон</h1>
      <v-card flat outlined class="new-doorphone-page__type-card">
        <v-card-text class="py-2 px-3">
          <v-autocomplete
            label="Тип домофона"
            :items="typeDoorphones"
            v-model="typeDoorphone"
            readonly
            item-text="name"
            prepend-inner-icon="mdi-format-list-bulleted-type"
            item-value="value"
            outlined
            dense
            hide-details
            class="new-doorphone-page__type-select"
          />
        </v-card-text>
      </v-card>
    </div>
    <component
      v-if="typeDoorphone === 'M' && $checkPermission('create_doorphone')"
      :is="DoorphoneForm"
    />
    <component
      v-if="typeDoorphone === 'G' && $checkPermission('create_gate')"
      :is="NewGate"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import DoorphoneForm from '@/components/doorphone/NewDoorphone/DoorphoneForm';
import NewGate from '@/components/doorphone/NewDoorphone/NewGate';

export default {
  name: 'DoorphoneNew',
  data () {
    return {
      DoorphoneForm,
      NewGate,
      valid: true,
      value: '',
      typeDoorphone: 'M',
      typeDoorphones: [
        {
          value: 'M',
          name: 'Домофон',
        },
        {
          value: 'G',
          name: 'Калитка',
        },
      ],
      items: [
        {
          text: 'Домофоны',
          disabled: false,
          href: '/doorphones',
        },
        {
          text: 'Новый домофон',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      loadManagementCompanies: 'ManagementCompany/getManagementCompanies',
    }),
  },
  created () {
    this.loadManagementCompanies();
  },
};
</script>

<style lang="scss" scoped>
.new-doorphone-page {
  max-width: 100%;
}

.new-doorphone-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}

.new-doorphone-page__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.new-doorphone-page__type-card {
  border-radius: 12px;
  max-width: 280px;
  flex-shrink: 0;
}

.new-doorphone-page__type-select {
  max-width: 280px;
}

@media screen and (max-width: 600px) {
  .new-doorphone-page__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .new-doorphone-page__type-card {
    max-width: 100%;
    width: 100%;
  }

  .new-doorphone-page__type-select {
    max-width: none;
  }
}
</style>
